/**
 * API client dedicato alla PWA Letturisti
 * Gestisce tutte le chiamate verso /api/pwa/*
 */
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/runtimeUrls';

const baseURL = getApiBaseUrl();

const pwaClient = axios.create({
  baseURL: `${baseURL}/pwa`,
  headers: { 'Content-Type': 'application/json' }
});

// Interceptor: aggiungi token da localStorage
pwaClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('pwa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor: gestisci 401
pwaClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pwa_token');
      localStorage.removeItem('pwa_user');
      window.location.href = '/letture/login';
    }
    return Promise.reject(error);
  }
);

const pwaApi = {
  // Auth
  login: (username, password, tenantSlug) =>
    pwaClient.post('/auth/login', { username, password, tenantSlug }).then(r => r.data),

  // Impianti
  getPlants: (params) =>
    pwaClient.get('/plants', { params }).then(r => r.data),

  getProvinces: () =>
    pwaClient.get('/plants/provinces').then(r => r.data),

  getPlantMeters: (plantId) =>
    pwaClient.get(`/plants/${plantId}/meters`).then(r => r.data),

  getPlantNotes: (plantId) =>
    pwaClient.get(`/plants/${plantId}/notes`).then(r => r.data),

  // Letture
  saveBatchReadings: (data) =>
    pwaClient.post('/readings/batch', data).then(r => r.data),

  // Foto
  uploadReadingPhotos: (readingId, formData) =>
    pwaClient.post(`/readings/${readingId}/photos`, formData, {
      headers: { 'Content-Type': undefined }
    }).then(r => r.data),

  uploadPlantPhotos: (plantId, formData) =>
    pwaClient.post(`/plants/${plantId}/photos`, formData, {
      headers: { 'Content-Type': undefined }
    }).then(r => r.data),

  uploadMeterPhotos: (meterId, formData) =>
    pwaClient.post(`/meters/${meterId}/photos`, formData, {
      headers: { 'Content-Type': undefined }
    }).then(r => r.data),

  getReadingPhotos: (readingId) =>
    pwaClient.get(`/readings/${readingId}/photos`).then(r => r.data),

  // Note intervento
  completeInterventionNote: (noteId, noteCompletamento) =>
    pwaClient.patch(`/intervention-notes/${noteId}/complete`, { note_completamento: noteCompletamento }).then(r => r.data),

  // Draft / Bozze
  getDraft: (plantId) =>
    pwaClient.get(`/plants/${plantId}/draft`).then(r => r.data),

  saveDraft: (plantId, data) =>
    pwaClient.put(`/plants/${plantId}/draft`, data).then(r => r.data),

  deleteDraft: (plantId) =>
    pwaClient.delete(`/plants/${plantId}/draft`).then(r => r.data),

  // Sync offline
  getSyncData: () =>
    pwaClient.get('/sync/data').then(r => r.data),

  uploadSyncBatches: (batches) =>
    pwaClient.post('/sync/upload', { batches }).then(r => r.data),
};

export default pwaApi;
